import EventEmitter from "eventemitter3";

export type Events = {
  saveActivityChanges: () => void;
  saveCompanyChanges: () => void;
  saveDealChanges: () => void;
  savePersonChanges: () => void;
  saveTripChanges: () => void;
};

const eventEmitter = new EventEmitter<Events>();

export default eventEmitter;
